import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PolicyService } from '../../../FunctionalModules/PolicyIssuance/policy.service';

import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-view-policy-summary',
  templateUrl: './view-policy-summary.component.html',
  styleUrls: ['./view-policy-summary.component.scss']
})
export class ViewPolicySummaryComponent implements OnInit {
  _currentComponentName = 'ViewPolicySummaryComponent'
  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private policyService: PolicyService,
    private appMetadataHandlerConfig: AppMetadataHandler
  ) { }

  //Declaraions which might need developer input
  viewPolicySummaryForm: FormGroup
  VIEWPOLICYSUMMARYFORM = "viewPolicySummaryForm"
  selectorOfThisComponent = 'app-claims-basic-details'
  parentEvent$
  appMetadataHandler = this.appMetadataHandlerConfig

  selectedpolicy: any;
  selectPolNum: any;
  ownerClientDO: any;
  primaryInsuredClientDO: any;

  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() DO: any;
  @Input() transactionState: any;

  _IO = null;
  @Input()
  set IO(value: any) {
    this._IO = value;
    this.getDOAndSetPolicy();
  };

  private getDOAndSetPolicy() {
    this.DO = this.getDO(this._IO);
    if (this.DO != null) {
      let anyPolicy = this.DO.find(item => true)
      if (anyPolicy)
        this.selectPolNum = anyPolicy['proposalNum'] ? anyPolicy['proposalNum'] : anyPolicy['proposalNum'];
      this.selectedpolicy = this.findPolicyByNum(this.selectPolNum);
      let ownerClient = this.selectedpolicy.proposalDO.proposalClients.find(item => item.roleCd === 'OWNER');
      if (ownerClient)
        this.ownerClientDO = this.selectedpolicy.clientDOs.find(item => (item !== null && item.guid === ownerClient.clientRefGuid))
      let primaryInsuredClient = this.selectedpolicy.proposalDO.proposalClients.find(item => item.roleCd === 'PRIMARYINSURED')
      if (primaryInsuredClient)
        this.primaryInsuredClientDO = this.selectedpolicy.clientDOs.find(item => item.guid === primaryInsuredClient.clientRefGuid)

      this.getPackage(this.selectedpolicy);
      console.log("selected policy details", JSON.stringify(this.selectedpolicy));
    }
  }

  get IO() {
    return this._IO;
  }


  getDO(IO) {
    let output = null
    if (IO != null) {
      switch (this.transactionState) {
        case "policy": {
          if (IO['intimationDO'] || IO['claimDO'] || IO['investigationDO'] || IO['proposalDO'] || IO['caseDO']) {
            //    output = IO['intimationDO']['policies'] || IO['claimDO']['policies'];
            if (IO['intimationDO'])
              output = IO['intimationDO']['policies']

            if (IO['claimDO'])
              output = IO['claimDO']['policy']

            if (IO['investigationDO'])
              output = IO['investigationDO']['policy']

            if (IO['caseDO'])
              output = IO['caseDO']['policy']

            break;
          }
        }
        case "proposal_DataEntry": {
          if (IO['proposalDO'])
            output = IO['proposalDO']['policy']

          break;
        }
        default: {
          console.log("Invalid choice");
          break;
        }
      }
    }

    return output
  }



  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      this.EmitComponentOutput(null);
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }


  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }

    if (this.IO != null)
      this.initializeClientSearchForm(this.IO)
    this.subscribeToParentEvent()
    this.subscribeToPolicyListAndInitializeRibbon()
  }



  /**
   * Form Trasactions
   */

  initializeClientSearchForm(data?) {
    let payload = data || {}
    this.viewPolicySummaryForm = this.fb.group({

    });
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.VIEWPOLICYSUMMARYFORM
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }

  findPolicyByNum(proposalNum) {
    let output = {}
    if (proposalNum) {
      this.selectPolNum = proposalNum;
      this.policyService.getPolicyByPolicyNum(this.selectPolNum).subscribe(resp => {
        this.selectedpolicy = resp;
        output = this.selectedpolicy;

        // this.getAgentDetails(this.selectedpolicy);
      },
        (error) => {
          throw " Something went wrong";
        }
      );

    }
    else {
      output = this.DO.find(item => true) || []
    }

    console.log("=========================", output);
    return output;

  }

  // agentDetailsList = [];
  // getAgentDetails(proposalDO) {
  //   if (proposalDO && proposalDO['proposalDO'] && this.commonUtilty.isArrayIterable(proposalDO['proposalDO']['policyAgentList'])) {
  //     this.policyService.getListOfAgentDOsByPolicyAgentList(proposalDO['proposalDO']['policyAgentList']).subscribe(resp => {
  //       this.agentDetailsList = this.commonUtilty.deepCopy(resp);
  //     })
  //     // proposalDO['proposalDO']['policyAgentList'].forEach(element => {
  //     //   this.policyService.getAgentByNum(element.agentNum).subscribe(resp => {
  //     //     this.agentDetailsList.push(this.commonUtilty.deepCopy(resp));
  //     //   });
  //     // });
  //   }
  // }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = '-'
    }
    return dateString
  }


  getOwnerName(proposalNum) {

    let filterOutput = null;
    let output = {}
    let ownerRefGuid;
    let name = null;
    if (this.selectedpolicy != undefined && proposalNum != null) {
      let clientDO = this.selectedpolicy['clientDOs'];
      if (this.selectedpolicy != null && this.selectedpolicy['proposalDO']['proposalClients'] != null) {
        ownerRefGuid = this.selectedpolicy['proposalDO']['proposalClients'].find(item => {
          if (item)
            return item['roleCd'] == 'OWNER';
        }) || []

        if (clientDO && this.commonUtilty.isArrayIterable(clientDO)) {
          filterOutput = clientDO.find(item => {
            if (item)
              return item['guid'] === ownerRefGuid.clientRefGuid;
          }) || []
        }

      }

      if (filterOutput != null) {

        let firstName = this.commonUtilty.getFirstNameFromClient(filterOutput)
        let lastName = this.commonUtilty.getLastNameFromClient(filterOutput);
        if (firstName == null)
          firstName = '-'
        if (lastName == null)
          lastName = '-'
        output['name'] = firstName + " " + lastName,
          output['isAvailable'] = true;
      }
      else {
        output['name'] = '-';
        output['isAvailable'] = false;
      }
    }

    return output;
  }

  profilePanelOpen = false;
  profilePanel(status) { this.profilePanelOpen = !!status }


  PolicyListAndInitializeRibbon$
  subscribeToPolicyListAndInitializeRibbon() {
    if (this.PolicyListAndInitializeRibbon$) this.PolicyListAndInitializeRibbon$.unsubscribe()
    this.PolicyListAndInitializeRibbon$ = this.interactService.policySubject$.subscribe(policies => {
      this.fetchAndInitializeRibbonDetails(policies);
    })
  }

  fetchAndInitializeRibbonDetails(policies?) {
    if (policies && policies != undefined && policies.length > 0 && this._IO == null) {
      this.DO = policies
      if (this.DO && this.DO.length > 0) {
        let policydata = this.DO.find(item => true)
        if (policydata)
          this.selectPolNum = policydata.proposalNum;
      }
    }
    else if (policies && policies.length == 0) {
      this.DO = [];
      this.selectPolNum = null;
    }
    else {
      let item
      if (this._IO != null) {
        this.DO = this.commonUtilty.getDO(this._IO);
      }

      if (this.DO && Array.isArray(this.DO)) {
        item = this.DO.find(item => true)
      }
      else {
        item = this.commonUtilty.deepCopy(this.DO)
        this.DO = [item]
      }

      if (item)
        this.policyGuid = item.guid;
    }

    if (!this.policyGuid && this.selectPolNum && this.selectPolNum != undefined && this._IO == null)
      this.selectedpolicy = this.findPolicyByNum(this.selectPolNum);
    else if (this.policyGuid) {
      this.policyService.getPolicyByPolicyGuid(this.policyGuid).subscribe(resp => {
        this.selectedpolicy = Object.assign({}, resp)
        this.selectedpolicy['proposalDO'] = this.commonUtilty.getDO(resp);
        console.log("selected policy", this.selectedpolicy);
        let ownerClient = this.selectedpolicy.proposalDO.proposalClients.find(item => item.roleCd === 'OWNER');
        if (ownerClient)
          this.ownerClientDO = this.selectedpolicy.clientDOs.find(item => (item !== null && item.guid === ownerClient.clientRefGuid))
        let primaryInsuredClient = this.selectedpolicy.proposalDO.proposalClients.find(item => item.roleCd === 'PRIMARYINSURED')
        if (primaryInsuredClient)
          this.primaryInsuredClientDO = this.selectedpolicy.clientDOs.find(item => item.guid === primaryInsuredClient.clientRefGuid)
        this.getPackage(this.selectedpolicy);
      })
    }
    else
      this.selectedpolicy = null
  }


  getClientName(client, proposalNum) {

    if (!proposalNum) {
      proposalNum = 1234;
    }

    let filterOutput = null;
    let output = "";

    if (this.selectedpolicy != undefined && proposalNum != null) {
      let clientDO = this.selectedpolicy['clientDOs'];

      if (this.selectedpolicy != null && this.selectedpolicy['proposalDO']['proposalClients'] != null) {
        filterOutput = clientDO.find(item => item && item['guid'] === client.clientRefGuid) || [];
      }

      if (filterOutput != null) {
        const firstName = this.commonUtilty.getFirstNameFromClient(filterOutput);
        const lastName = this.commonUtilty.getLastNameFromClient(filterOutput);

        if (firstName != null) {
          output += firstName;
        }

        if (lastName != null) {
          output += (firstName != null ? " " : "") + lastName;
        }
      }
    }

    return output;

  }


  getExternalClientNum(client, proposalNum) {
    if (!proposalNum) {
      proposalNum = 1234;
    }
    let filterOutput = null;
    let output = "-";
    let name = null;
    if (this.selectedpolicy != undefined && proposalNum != null) {
      let clientDO = this.selectedpolicy['clientDOs'];
      if (this.selectedpolicy != null && this.selectedpolicy['proposalDO']['proposalClients'] != null) {

        filterOutput = clientDO.find(item => {
          if (item)
            return item['guid'] === client.clientRefGuid;
        }) || []

      }
      if (filterOutput != null) {
        output = filterOutput['externalClientNum'];
      }
      else {
        output = '-';

      }
    }
    return output;

  }

  getClientNum(client, proposalNum) {
    if (!proposalNum) {
      proposalNum = 1234;
    }
    let filterOutput = null;
    let output = "-";
    let name = null;
    if (this.selectedpolicy != undefined && proposalNum != null) {
      let clientDO = this.selectedpolicy['clientDOs'];
      if (this.selectedpolicy != null && this.selectedpolicy['proposalDO']['proposalClients'] != null) {

        filterOutput = clientDO.find(item => {
          if (item)
            return item['guid'] === client.clientRefGuid;
        }) || []

      }
      if (filterOutput != null) {
        output = filterOutput['clientNum'];
      }
      else {
        output = '-';

      }
    }
    return output;

  }

  getAgentName(agentNum) {
    let output = '-';
    let agentOutput = null;
    if (this.selectedpolicy['agentDOs'] && this.selectedpolicy['agentDOs'].length && this.selectedpolicy['agentDOs'].length > 0) {
      agentOutput = this.selectedpolicy['agentDOs'].find(item => {
        if (item)
          return item.agentNum === agentNum;
      })
    }

    if (this.selectedpolicy['clientDOs'] && this.selectedpolicy['clientDOs'].length && this.selectedpolicy['clientDOs'].length > 0) {
      this.selectedpolicy['clientDOs'].forEach(item => {
        if (item.guid === agentOutput.clientRefGuid) {
          if (item && item.personDO)
            output = item.personDO.firstName + " " + item.personDO.lastName;
        }
      })
    }
    return output;
  }

  getAgentChannel(agentNum) {
    let channelCd = '-'
    if (this.selectedpolicy['agentDOs'] && this.selectedpolicy['agentDOs'].length && this.selectedpolicy['agentDOs'].length > 0) {
      this.selectedpolicy['agentDOs'].forEach(item => {
        if (item.agentNum === agentNum)
          channelCd = item.channelCd;
      });
    }
    return channelCd;
  }

  packageType = null;
  getPackage(selectedPolicy) {
    if (selectedPolicy) {
      let DO = selectedPolicy['proposalDO'] ? 'proposalDO' : 'caseDO';
      let CoverageNode = (selectedPolicy['proposalDO'] && selectedPolicy['proposalDO']['proposalCoverages']) ? 'proposalCoverages' : 'caseCoverages';
      let basePlan = selectedPolicy[DO][CoverageNode].find(item => item.planTypeCd === 'BASEPLAN')
      if (basePlan)
        this.packageType = basePlan.packageCd;
    }
  }

  selectedClientDO: any;
  getClientDOofSelectedClient(client) {
    if (client) {
      this.selectedClientDO = (this.selectedpolicy && this.commonUtilty.isArrayIterable(this.selectedpolicy.clientDOs)) ? this.selectedpolicy.clientDOs.find(item => item.guid === client.clientRefGuid) : null;
      this.profilePanelOpen = true
    }
  }


  viewLaModal = false;
  intimationMetaDataTable;
  viewLADetails() {
    this.viewLaModal = true;
    console.log(this.selectPolNum);
    if (this.selectPolNum) {
      // need to remove 
      // this.intimationMetaDataTable = [{ "batch_DESCRIPTION": "Death Claim Repudiation", "batch_CODE": "T5E1", "date_SUB": 1536690600000, "policy_NO": "21963907", "effective_DATE": 1536690600000, "system_TRANSACTION_DATE": 1536690600000 }, { "batch_DESCRIPTION": "Death Claim Registration", "batch_CODE": "T668", "date_SUB": 1530037800000, "policy_NO": "21963907", "effective_DATE": 1530037800000, "system_TRANSACTION_DATE": 1530037800000 }, { "batch_DESCRIPTION": "Death Claim Intimation", "batch_CODE": "TJ06", "date_SUB": 1530037800000, "policy_NO": "21963907", "effective_DATE": 1530037800000, "system_TRANSACTION_DATE": 1530037800000 }, { "batch_DESCRIPTION": "Full Contract Reversal", "batch_CODE": "T656", "date_SUB": 1530037800000, "policy_NO": "21963907", "effective_DATE": 1530037800000, "system_TRANSACTION_DATE": 1530037800000 }, { "batch_DESCRIPTION": "Renewals Overdue Processing", "batch_CODE": "B673", "date_SUB": 1489257000000, "policy_NO": "21963907", "effective_DATE": 1486665000000, "system_TRANSACTION_DATE": 1530037800000 }];
      let pathVariables = [];
      pathVariables.push(this.selectPolNum);
      this.intimationMetaDataTable = this.apiRequestService.getCallWithAPIMapper('fetchLATransByPolicyNum', null, null, pathVariables)
        .subscribe(data => {
          if (data && data.length) {
            this.intimationMetaDataTable = data;
          }
        })
    }
  }


  viewNotesModal = false;
  viewClaimModal = false;
  viewMedicalModal = false;

  viewNotes() {
    this.viewNotesModal = true;
  }

  viewClaims() {
    this.viewClaimModal = true;
  }


  viewMedical() {
    this.viewMedicalModal = true;
  }
  /* For Document Manager */
  policyGuid: any = false;

  templreInsuredListToshow = [

    {
      "insurerName": "",
      "Sumceeded": "",
      "RetentionAmount": "",

    }
  ]

}

